var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#star-outline--Dg9x3';
                    var viewUrl = 'sprites.svg#view-star-outline--Dg9x3';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };